import { createTheme } from '@mantine/core';

export const theme = createTheme({
  // Customize your tenant's theme here
  // See https://mantine.dev/theming/theme-object/
  defaultRadius: 'md',
});
